// extracted by mini-css-extract-plugin
export default {"debug":"debug_debug"};